// src/components/ui/pixel-loader/pixel-loader.tsx

import React from 'react';
import { motion } from 'framer-motion';

export const PixelLoader: React.FC = () => {
  return (
    <div className="fixed inset-0 bg-retro-crtDark flex items-center justify-center z-50">
      <div className="text-center">
        {/* Pixel Spinner */}
        <div className="relative w-32 h-32 mx-auto mb-8">
          <motion.div
            className="absolute inset-0"
            animate={{ rotate: 360 }}
            transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
          >
            {[0, 45, 90, 135, 180, 225, 270, 315].map((rotation) => (
              <div
                key={rotation}
                className="absolute w-4 h-4 bg-retro-neonGreen"
                style={{
                  top: '50%',
                  left: '50%',
                  transform: `rotate(${rotation}deg) translateY(-200%)`,
                  transformOrigin: '0 0',
                  boxShadow: '0 0 10px #00FF41',
                }}
              />
            ))}
          </motion.div>
          
          {/* Center dot */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <div className="w-4 h-4 bg-retro-neonYellow animate-pulse shadow-neon-yellow" />
          </div>
        </div>

        {/* Loading Text */}
        <div className="font-pixel text-xs text-retro-neonGreen mb-4">
          LOADING<span className="animate-pixel-blink">...</span>
        </div>

        {/* Progress Bar */}
        <div className="w-48 h-4 mx-auto border-2 border-retro-neonGreen bg-retro-screen">
          <motion.div
            className="h-full bg-retro-neonGreen"
            initial={{ width: '0%' }}
            animate={{ width: '100%' }}
            transition={{ duration: 2, repeat: Infinity }}
            style={{
              boxShadow: '0 0 10px #00FF41',
            }}
          />
        </div>
      </div>
    </div>
  );
};